/* home.js — scroll reveal for the landing page (.hm-rv elements).
   No dependencies. Respects prefers-reduced-motion via CSS (elements
   are fully visible there; the observer still runs harmlessly). */
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.hm-rv').forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.hm-rv').forEach(function (el) { io.observe(el); });
})();
